/* eslint-disable max-len */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState, useCallback } from 'react';

import classes from './index.module.css';

const LandingPage = () => {
  const [parentWindow, setParentWindow] = useState(null);
  const navigate = useNavigate();
  const channel = new BroadcastChannel(process.env.BROADCART_CHANNEL_NAME);
  // const { referer } = document;
  // const showCloseButton = referer.indexOf(process.env.OPEN_PLATFORM_HOSTNAME) > -1;
  const closeHandler = useCallback(() => {
    if (parentWindow) {
      channel.postMessage('Authentication Complete');
      window.close?.();
    } else {
      navigate('/');
    }
  }, [parentWindow]);

  useEffect(() => {
    console.log('shout');
    channel.postMessage('shout');

    const timer = setTimeout(() => {
      setParentWindow(false);
    }, 500);

    channel.onmessage = (ev) => {
      console.log(ev.data);
      if (ev.data === 'echo') {
        setParentWindow(true);
        clearTimeout(timer);
      }
    };
  }, []);

  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <FontAwesomeIcon icon={faCircleCheck} style={{ color: 'green', fontSize: 100 }} />
        <div className={classes.text}>Authentication Complete!</div>
        <div className={classes.button_group}>
          {/* eslint-disable-next-line no-nested-ternary */}
          <div className={classes.button} style={parentWindow === null ? { display: 'none' } : {}} onClick={closeHandler}>{parentWindow !== null ? (parentWindow ? 'Close Window' : 'Redirect to Open Platform') : ''}</div>
          {/* <div className={classes.button} onClick={redirectHandler}>Redirect to Open Platform</div> */}
          {/* {
            showCloseButton
              ? <div className={classes.button} onClick={closeHandler}>Close Window</div>
              : <div className={classes.button} onClick={redirectHandler}>Redirect to Open Platform</div>
          } */}
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
